<template>
  <div class="boxbgcolor finance">
    <!--左侧树形索引-->
    <div class="left content-left">
      <AreaTree ref="table" v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div>
    <div class="content-right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <span class="demonstration">月:</span>
            <el-date-picker v-model="value4" type="month" placeholder="选择月"></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button @click="searchList" type="primary" :loading="loading" size="small">查询</el-button>
            </span>
            <span class="download_btn">
              <button @click="downloadExcel" type="button" class="btn btn-primary">导出EXCEl</button>
            </span>
          </div>
        </form>
      </div>
      <div class="list">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-loading="loading"
        >
          <el-table-column fixed show-overflow-tooltip label="收费员名称" prop="name"></el-table-column>
          <el-table-column show-overflow-tooltip label="时间">
            <template>
              <span class="to-block">应收</span>
              <span class="to-block">实收</span>
              <span class="to-block last-row">收费率</span>
            </template>
          </el-table-column>

          <el-table-column
            v-for="(item,index) in tableLabelData"
            :key="item"
            show-overflow-tooltip
            :label="item"
          >
            <template slot-scope="scope">
              <span class="to-block">{{scope.row.chargeDateList[index].receivable}}</span>
              <span class="to-block">{{scope.row.chargeDateList[index].realMoney}}</span>
              <span class="to-block last-row">{{scope.row.chargeDateList[index].rate}}</span>
            </template>
          </el-table-column>

          <el-table-column show-overflow-tooltip label="总计">
            <template slot-scope="scope">
              <span class="to-block">{{scope.row.attr2}}</span>
              <span class="to-block">{{scope.row.attr1}}</span>
              <span class="to-block last-row">{{scope.row.attr3}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import AreaTree from "../../commons/areaTree";
import {
  getChargeUserMonthyMoney,
  getChargeUserStatisticsList,
  getAllAreaByParkingId,
} from "@/api/url";

import Page from "../../commons/page";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      treeData: {
        parentId: "",
      },
      moduleName: "parking",
      search: {
        pageNumber: 1,
        pageSize: 10,
        year: "",
        month: "",
        monthDays: "",
      },
      value4: "",
      tableListData: [],
      tableLabelData: [],
      pageObj: {},
      loading: false,
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.value4 = "";
      this.search.month = "";
      this.search.year = "";
      if (node.type != "property") {
        this.treeData.parentId = "";
        var pageObj = {
          curIndex: 1,
          rowsCount: 0,
        };
        this.getPage(pageObj);
        this.tableListData = [];
        return;
      } else {
        this.treeData.parentId = node.id;
        this.onClickInitTableList();
      }
    },
    tableLabel() {
      this.tableLabelData = [];
      for (let i = 1; i <= this.search.monthDays; i++) {
        const tempLabel =this.search.month + "月" + this.zeroFill(i) + "日";
        this.tableLabelData.push(tempLabel);
      }
    },
    onClickInitTableList() {
      this.getDateNow(new Date());
      this.tableLabel();
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      var _this = this;
      this.loading=true;
      this.$get(getChargeUserStatisticsList(), {
        parkingId: this.treeData.parentId,
        date: this.search.year + "-" + this.zeroFill(this.search.month),
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.pageObj={...pageObj}
        // this.getPage(pageObj);
        this.tableListData = this.formatTableListData(data.data.rows);
        this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(()=>{
        this.loading=false;
      })
    },
    formatTableListData(data) {
      data.map((item) => {
        const chargeList = item?.chargeDateList ?? [];
        if (chargeList.length < this.search.monthDays) {
          for (let i = chargeList.length + 1; i <= this.search.monthDays; i++) {
            const tempData = {
              date:
                this.search.year +
                "-" +
                this.zeroFill(this.search.month) +
                "-" +
                this.zeroFill(i),
              receivable: 0,
              realMoney: 0,
              rate: "0.00%",
            };
            chargeList.push(tempData);
          }
        }
        item.chargeDateList = chargeList;
        return item;
      });
      return data;
    },
    downloadExcel() {
      if (!this.treeData.parentId) {
        this.$message({
          type: "warning",
          message: "请选择物业",
        });
        return;
      }
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/chargeStatisticsInspectorsExport",
        {
          date: this.search.year + "-" +this.zeroFill(this.search.month),
          parkingId: this.treeData.parentId,
        },
        "巡检员收费统计"
      );
    },
    searchList() {
      
        var _this = this;
        this.search.pageNumber = "1";
        if (!this.treeData.parentId) {
          this.$message({
            type: "warning",
            message: "请选择物业",
          });
          return;
        }
        if (this.value4) {
          this.getDateNow(this.value4);
          this.tableLabel();
        }
        this.tableList(this.search.pageNumber);
     
    },
    clearSearch: function () {},
    //获取年，月，日，月有多少天
    getDateNow(date) {
      this.search.year = date.getFullYear();
      this.search.month = Number(date.getMonth() + 1);
      this.search.monthDays = this.monthHasDays(date);
    },
    //计算某年某月有多少天
    monthHasDays(d) {
      let year = d.getFullYear().toString();
      let month = (d.getMonth() + 1).toString();
      let dd = new Date(year, month, 0);
      let days = dd.getDate();
      return days;
    },
    //zero fill
    zeroFill(n) {
      return n.toString().length <= 1 ? "0" + n : n;
    },
  },
  computed: {
    ...mapGetters(["elements"]),
  },
  components: {
    Page,
    AreaTree,
  },
  created: function () {},
  mounted: function () {
    this.getDateNow(new Date());
    this.tableLabel();
  },
  watch: {},
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;
  /* height:65px; */
  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
  overflow-x: auto;
  height: calc(100vh - 250px) !important;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
table {
  border: 1px solid #ccc;
}
table tr td {
  border: 1px solid #ccc;
}
.reload-container {
  display: inline-block;
  /* margin-top:8px; */
}
.reload {
  /* margin: 0px 10px; */
  cursor: pointer;
  color: #67c23a !important;
}
.reload:hover {
  color: rgb(45, 107, 15) !important;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}
.to-block {
  display: block;
}
.list span {
  border-bottom: 1px solid #eee;
}
.list span.last-row {
  border-bottom: none;
}
</style>
<style>
.finance .el-table__footer td .cell {
  text-align: center;
  font-weight: bold;
  color: black;
}
.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding-left: 0 !important;
}
.el-table .cell,
.el-table th div {
  padding-right: 0 !important;
}
</style>